var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20_w_ic_fh_warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M10 1L17.7942 5.5V14.5L10 19L2.20577 14.5V5.5L10 1Z",
    stroke: "#F26549",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M11.4678 5L11.122 10.613H8.91823L8.57239 5H11.4678ZM8.5 13.4522C8.5 13.0126 8.63941 12.6462 8.91823 12.3531C9.19705 12.0539 9.55898 11.9043 10.004 11.9043C10.4491 11.9043 10.8083 12.0539 11.0818 12.3531C11.3606 12.6462 11.5 13.0126 11.5 13.4522C11.5 13.8918 11.3606 14.2612 11.0818 14.5604C10.8083 14.8535 10.4491 15 10.004 15C9.55898 15 9.19705 14.8535 8.91823 14.5604C8.63941 14.2612 8.5 13.8918 8.5 13.4522Z",
    fill: "#F26549"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/IconWarning.8d37666879b2e3e19e44dadc900245f9.svg";
export { ForwardRef as ReactComponent };